import React__default, { useState, useCallback, useEffect } from 'react';
import { useId, TextInput, Typography } from '@vp/swan';
import debounce from '../../../../../../../../../lodash.debounce/index.mjs';
import { SimpleTitle } from '../../../../shared/simple-title/simple-title.mjs';

const StandardTextboxSkin = (props) => {
    const { option, onChanged, isDisabled, message } = props;
    const [inputText, setInputText] = useState(option.selectedKey ?? "");
    const titleId = useId();
    const infoId = useId();
    const errorId = useId();
    const handleInputChange = useCallback(debounce((value) => {
        onChanged({ choiceKey: value });
    }, 250), [onChanged]);
    useEffect(() => {
        if (option.selectedKey) {
            handleInputChange(option.selectedKey);
        }
    }, []);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SimpleTitle, { titleId: titleId }),
        React__default.createElement(TextInput, { disabled: isDisabled, skin: "standard", value: inputText, onChange: (event) => {
                setInputText(event.target.value);
                handleInputChange(event.target.value);
            }, "aria-required": option.isRequired, "aria-labelledby": titleId, "aria-describedby": infoId, "aria-invalid": message?.type === "error", "aria-errormessage": message?.type === "error" ? errorId : undefined }),
        message && message.type === "info" && (React__default.createElement(Typography, { id: infoId, mt: "2", fontSkin: "body-small", textColor: "subtle" }, message.text)),
        message && message.type === "error" && (React__default.createElement(Typography, { id: errorId, textColor: "error", fontSkin: "body-small", role: "status", "aria-live": "polite", mt: "2" }, message.text))));
};

export { StandardTextboxSkin };
//# sourceMappingURL=standard-textbox-skin.mjs.map
